<script>
export default {
	trackPageView: true,
}
</script>

<template>
	<RecetaDigitalManager />
</template>

